import React from 'react'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import { Box, Typography } from '@mui/material';
import { Icon } from 'leaflet';
import { Link } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ContactMap = () => {
    const center = {
        lat: 19.160861,  
        lng: 72.850944, 
      };
      const customIcon = new Icon({
        iconUrl : "https://cdn-icons-png.flaticon.com/128/9131/9131546.png" , 
        iconSize : [38 , 38]
      })
  return (
    <Box sx={{padding:'40px 10px' , color:'black'}}>
        <Box sx={{marginBottom:'20px'}}>
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 500 }}>
                    You are welcome to visit us with a prior appointment between 10am and 5pm on weekdays at our Mumbai office:
                </Typography>
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 400 , fontSize:'13px'}}>
                    707, Corporate Avenue, A-wing | Sonawala Road | Goregaon (E) | Mumbai 400063. India. 
                    Call or WhatsApp on <a href="https://wa.me/919969741869" target="_blank" rel="noopener noreferrer" className='text-blue-600'>+91-9969741869</a>/<a href="https://wa.me/918356832329" target="_blank" rel="noopener noreferrer" className='text-blue-600'> +91-8356832329</a> .
                    
                </Typography>        
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 400 , fontSize:'13px'}}>
                    Find us on Google Maps:   
                    <Link target='_blank' className='text-blue-600' to='https://maps.app.goo.gl/LwqKX43XQXoW2kj9A'>
                        <LocationOnIcon sx={{ color:'red'}}/>
                    </Link>
                   
                </Typography>        
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 400 , fontSize:'13px'}}>
                    
                    <span className='font-bold'>Directions to reach our Mumbai office Landmark:</span>
                         Above Indian Bank
                    5 minutes by walk from Goregaon Station (East).
                    If you are coming by Western Express Highway from the South, take a left at the HP Petrol Pump.
                </Typography>        
        </Box>
         <Box sx={{padding:2 , border:'1px solid #ccc' , borderRadius:'5px' ,maxWidth: '1200px' , margin:'auto'}}>
            {/*<MapContainer center={center} zoom={13} style={{ height: '500px', maxWidth: '100%'  , borderRadius:'5px'}}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://maps.app.goo.gl/LwqKX43XQXoW2kj9A">GuideStarIndia</a>'
                />
                <Marker position={center} icon={customIcon}>
                    <Popup>
                        GuideStar India
                    </Popup>
                </Marker>
            </MapContainer>*/}
            <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.7855732410367!2d72.8507344!3d19.1608612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b64cd9c309c1%3A0x35ba851794fc79b7!2sGuideStar%20India!5e0!3m2!1sen!2sin!4v1743590449580!5m2!1sen!2sin" 
                width="600" 
                height="450" 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade" 
                title="Google Maps - GuideStar India">
            </iframe>        </Box> 
        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.7855732410367!2d72.8507344!3d19.1608612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b64cd9c309c1%3A0x35ba851794fc79b7!2sGuideStar%20India!5e0!3m2!1sen!2sin!4v1743586530214!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

    </Box>
  )
}

export default ContactMap